export const labels = {
  header: "Per continuare ci serve il tuo consenso al trattamento dei dati",
  submitLabel: "Accetta"
}
